export default __webpack_public_path__ + "fe3d5386feabed79da7bbb03b7c05840.svg";